import { FieldErrors } from 'react-hook-form'
import { JoinFormType } from 'src/types/react-hook-form'

export function getTermsErrorMessage(errors: FieldErrors<JoinFormType>) {
  return (
    errors.Service?.message ||
    errors.PrivacyThirdParty?.message ||
    errors.PrivacyConsent?.message ||
    errors.SKTPrivacy?.message ||
    errors.KTPrivacy?.message ||
    errors.LGUPPrivacy?.message
  )
}
